export default function automations(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                automation: action.automation,
            }
        default:
            return state;
    }
}
